<template>
  <Form ref="searchForm" inline :model="searchForm" :label-width="50" @keyup.enter.native="searchSubmit">
    <FormItem label="模糊" prop="search_all">
      <Input v-model="searchForm.search_all" placeholder="" style="min-width: 150px;"></Input>
    </FormItem>
    <FormItem label="编号" prop="wsid">
      <Input v-model="searchForm.wsid" placeholder="" style="min-width: 150px;"></Input>
    </FormItem>
    <FormItem label="标题" prop="title">
      <Input v-model="searchForm.title" placeholder="" style="min-width: 150px;"></Input>
    </FormItem>
    <FormItem label="分类" prop="type">
      <Select v-model="searchForm.type" placeholder="" style="min-width: 150px;">
        <Option v-for="item in workSheetTypeList" :key="item.id" :value="item.id">{{ item.type_name }}</Option>
      </Select>
    </FormItem>
    <FormItem label="提交人" prop="submitter">
      <Input v-model="searchForm.submitter" placeholder="" style="min-width: 150px;"></Input>
    </FormItem>
    <FormItem label="处理人" prop="operator" v-if="isOperatorDisplay">
      <Input v-model="searchForm.operator" placeholder="" style="min-width: 150px;"></Input>
    </FormItem>
    <FormItem :label-width="0" class="mob-align-right">
      <Button type="primary" @click="searchSubmit">搜索</Button>
      <Button @click="searchReset" style="margin-left: 10px">重置</Button>
      <Button type="primary" size="large" style="margin-left: 10px" @click="exportData('custom')" :style="{display: isDisplay}"><Icon type="ios-download-outline"></Icon>自定义导出</Button>
      <Button type="primary" style="margin-left: 10px" @click="exportData('system')" :style="{display: SystemDisplay === 'inline-block' ? 'inline-block' : 'none'}"><Icon type="ios-download-outline"></Icon>系统功能维护记录</Button>
    </FormItem>
  </Form>
</template>

<script>
import { GetALLWorkSheetType } from '@/api/logistics/type'
import eventVue from './event.js'

export default {
  name: 'search',
  props: ['tableColumns', 'isDisplay', 'isOperatorDisplay', 'SystemDisplay'],
  data () {
    return {
      searchForm: {
        wsid: '',
        title: '',
        type: '',
        submitter: '',
        operator: '',
        search_all: ''
      },
      workSheetTypeList: []
    }
  },
  mounted: function () {
    this.getWorkSheetAllTypeList()
  },
  methods: {
    searchReset () {
      this.searchForm = {
        wsid: '',
        title: '',
        type: '',
        submitter: '',
        operator: '',
        search_all: ''
      }
    },
    searchSubmit () {
      // console.log('searchSubmit  ' + this.searchForm.operator)
      eventVue.$emit('myFun', this.searchForm)
    },
    getWorkSheetAllTypeList () {
      GetALLWorkSheetType().then(res => {
        this.workSheetTypeList = res.data
      })
    },
    exportData (type) {
      this.$emit('on-result-change', type)
    }
  }
}
</script>

<style scoped>

</style>
